import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Phone, MapPin } from "lucide-react";
import { BRAND, LOCATIONS, NAV, IMAGES } from "../data/site";

export const Footer = () => {
  return (
    <footer
      className="bg-ink text-bone pt-1 pb-12 mt-0"
      data-testid="site-footer"
    >
      <div className="container-wide">
        {/* <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <Link to="/" data-testid="header-logo-link">
              <img
                src={IMAGES.logo}
                alt="Smiles by Dr. K Logo"
                className="h-12 w-auto"
              />
            </Link>
            <p className="font-serif italic text-3xl mt-8 leading-tight text-gold-light max-w-md">
              "{BRAND.tagline}"
            </p>
            <p className="mt-6 text-white/60 max-w-md leading-relaxed text-sm">
              Two Locations.One Philosophy.Personalized Dentistry by Dr.K
            </p>
            <div className="flex gap-4 mt-8">
              <a
                href="https://instagram.com"
                aria-label="Instagram"
                data-testid="footer-instagram"
                className="w-10 h-10 border border-white/20 hover:border-gold hover:text-gold flex items-center justify-center transition-colors"
              >
                <Instagram size={16} strokeWidth={1.2} />
              </a>
              <a
                href="https://facebook.com"
                aria-label="Facebook"
                data-testid="footer-facebook"
                className="w-10 h-10 border border-white/20 hover:border-gold hover:text-gold flex items-center justify-center transition-colors"
              >
                <Facebook size={16} strokeWidth={1.2} />
              </a>
              <a
                href="mailto:hello@smilesbydrk.com"
                aria-label="Email"
                data-testid="footer-email"
                className="w-10 h-10 border border-white/20 hover:border-gold hover:text-gold flex items-center justify-center transition-colors"
              >
                <Mail size={16} strokeWidth={1.2} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="label-eyebrow text-gold mb-6">Explore</div>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <Link
                    to={n.href}
                    data-testid={`footer-link-${n.label.toLowerCase()}`}
                    className="text-white/80 hover:text-gold text-sm tracking-wide transition-colors"
                  >
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="label-eyebrow text-gold mb-6">Studios</div>
            <div className="space-y-8">
              {LOCATIONS.map((loc) => (
                <div key={loc.slug} data-testid={`footer-location-${loc.slug}`}>
                  <div className="font-serif text-xl">{loc.name}</div>
                  <div className="text-white/60 text-sm mt-2 flex items-start gap-2">
                    <MapPin
                      size={14}
                      strokeWidth={1.2}
                      className="mt-0.5 flex-shrink-0"
                    />
                    <span>{loc.address}</span>
                  </div>
                  <div className="text-white/60 text-sm mt-2 flex items-center gap-2">
                    <Phone size={14} strokeWidth={1.2} />
                    <a
                      href={`tel:${loc.phone.replace(/\D/g, "")}`}
                      className="hover:text-gold transition-colors"
                    >
                      {loc.phone}
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div> */}
        <div className="border-t border-gold py-12">
          <div className="max-w-7xl mx-auto px-6 flex flex-col items-center gap-3">
            <div className="flex items-center gap-3 sm:gap-4">
              <span className="font-script text-[28px] leading-none text-white-light">Smiles</span>
              <a
                href="/"
                onClick={() => window.scrollTo(0, 0)}
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity"
              >
                <img
                  src={IMAGES.logo}
                  alt="Smiles by Doctor K"
                  className="h-12 w-auto"
                />
              </a>
              <span className="font-script text-[28px] leading-none text-white-light">by Dr.K</span>
            </div>
            <p className="text-md text-white/70 text-center">
              Two Locations. One Philosophy.Personalized Dentistry by Dr.K
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 mt-1 text-center">
              <a
                href="https://gdentalspa.com/"
                target="_blank"
                rel="noopener noreferrer"
                // onClick={() => window.scrollTo(0, 0)}
                className="text-white/70 hover:text-gold transition-colors"
              >
                <span className="inline font-script text-2xl">Galleria Dental <span className="text-sm text-[#00ff1a]">Spa</span></span><span className="inline"> (Manalapan, NJ)</span>
                {/* <span className="block text-sm tracking-wide text-white/50">
                  gdental spa
                </span> */}
              </a>
              <span className="hidden sm:block h-px w-8 bg-white/60" />
              <a
                href="https://edentalspa.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/70 hover:text-gold transition-colors"
              >
                <span className="inline font-script text-2xl">Essential Dental <span className="text-sm text-[#00FFFF]">Spa</span></span><span className="inline"> (Roslyn Heights, NY)</span>
                {/* <span className="block text-sm tracking-wide text-white/50">
                  edental spa
                </span> */}
              </a>
            </div>
          </div>
        </div>
        {/* Big brand mark */}
        {/* <div className="mt-24 mb-10 overflow-hidden">
          <div className="font-serif text-[12vw] md:text-[12vw] lg:text-[10vw] leading-none text-white/[0.06] tracking-tighter whitespace-nowrap select-none">
            Smile Well. Live Well.
          </div>
        </div> */}

        <div className="border-t border-gold pt-8 flex flex-col md:flex-row justify-center items-start md:items-center gap-4 text-xs text-white/40">
          <div>
            © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
          </div>
          {/* <div className="flex gap-6">
            <a href="#privacy" className="hover:text-gold transition-colors">
              Privacy
            </a>
            <a
              href="#accessibility"
              className="hover:text-gold transition-colors"
            >
              Accessibility
            </a>
            <a href="#hipaa" className="hover:text-gold transition-colors">
              HIPAA Notice
            </a>
          </div> */}
        </div>
      </div>
    </footer>
  );
};
